var $042c971985d4b96a$exports = {};
$042c971985d4b96a$exports = {
    "maximum": `Maksimi`,
    "minimum": `Minimi`
};


export {$042c971985d4b96a$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
